import {
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react'
import { map } from 'lodash'
import useReports from '../../../../hooks/useReports'
import { formatMonth } from '../../../../utils/formatMonth'
import { VitalStatsTableProps } from '../utils/types'

export const VitalStatsTable = ({ reports }: VitalStatsTableProps) => {
  const loggedInUserReports = useReports()
  if (!reports) {
    reports = loggedInUserReports
  }

  return (
    <Stack spacing={4}>
      <TableContainer>
        <Table size='sm' variant='unstyled'>
          <Thead>
            <Tr>
              <Th>Month</Th>
              <Th>Weight</Th>
              <Th>
                O2
                <br />
                Sat%
              </Th>
              <Th>
                Heart
                <br />
                Rate
              </Th>
              <Th>
                Blood
                <br />
                Pressure
              </Th>
              <Th>
                PH Test
                <br />
                Urine
              </Th>
              <Th>
                PH Test
                <br />
                Saliva
              </Th>
              <Th>
                Basal Body
                <br />
                Temp.
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {map(reports, (report, key) => {
              const stats = report?.vitalStats
              if (!stats) return null

              return (
                <Tr key={key}>
                  <Td>{formatMonth(key)}</Td>
                  <Td>
                    {stats.weight}
                    {stats.units === 'imperial' ? 'lbs' : 'kg'}
                  </Td>
                  <Td>{stats.o2saturation}</Td>
                  <Td>{stats.heartRate}</Td>
                  <Td>
                    {stats.systolic}/{stats.diastolic}
                  </Td>
                  <Td>{stats.phTestUrine}</Td>
                  <Td>{stats.phTestSaliva}</Td>
                  <Td>{stats.basalBodyTemperature}</Td>
                </Tr>
              )
            })}
          </Tbody>
        </Table>
      </TableContainer>
      <TableContainer>
        <Table size='sm' variant='unstyled'>
          <Thead>
            <Tr>
              <Th>Month</Th>
              <Th>
                Sed. Rate
                <br />
                (Urine)
              </Th>
              <Th>
                Glucose
                <br />
                Fasting
              </Th>
              <Th>
                Glucose 30 Min
                <br />
                After Meal
              </Th>
              <Th>
                Grip Str
                <br />
                Left
              </Th>
              <Th>
                Grip Str
                <br />
                Right
              </Th>
              <Th>
                Peak Flow
                <br />
                Meter
              </Th>

              <Th>
                Forced Vital
                <br />
                Capacity
              </Th>
              <Th>
                Slow Vital
                <br />
                Capacity
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {map(reports, (report, key) => {
              const stats = report?.vitalStats
              if (!stats) return null

              return (
                <Tr key={key}>
                  <Td>{formatMonth(key)}</Td>
                  <Td>{stats.sedRateUrine}</Td>
                  <Td>{stats.glucoseFasted}</Td>
                  <Td>{stats.glucoseAfterMeal}</Td>
                  <Td>{stats.gripLeft}</Td>
                  <Td>{stats.gripRight}</Td>
                  <Td>{stats.peakFlow}</Td>
                  <Td>{stats.fvc}</Td>
                  <Td>{stats.svc}</Td>
                </Tr>
              )
            })}
          </Tbody>
        </Table>
      </TableContainer>
    </Stack>
  )
}
